export default __webpack_public_path__ + "static/media/schedule.9a911f69.svg";